export const sampleResponse = [
  {
    dealership: "jones toyota",
    address: " 23 Main Rd,Bell,MD 56254",
    main_contact: "wallace",
    email: "admin@jones.com",
    phone: "225-256-1231",
    pulls: "120",
    standard_pulls: "100",
    per_pull_average: "$2",
    subscription_cost: "$490",
    docs_data: "docs/data",
  },
  {
    dealership: "jhon ",
    address: " 24 Main road  56254",
    main_contact: "wallace",
    email: "jhon@jones.com",
    phone: "223-235-1231",
    pulls: "220",
    standard_pulls: "120",
    per_pull_average: "$6",
    subscription_cost: "$480",
    docs_data: "docs",
  },
  {
    dealership: "jane ",
    address: " 24 Main road  56254",
    main_contact: "wallace",
    email: "jane@jones.com",
    phone: "223-211-1221",
    pulls: "280",
    standard_pulls: "140",
    per_pull_average: "$12",
    subscription_cost: "$980",
    docs_data: "data",
  },
];
export const historyResponse = [
  {
    time: "08:00 AM",
    dealer_ship: " Jones Toyota",
    employee: "Alex wallace",
    customer: "Robin Riz",
    email: " robin@gmail.com",
    contact_number: " 401-255-2556",
    vehicle: "12357998881234567",
    status: "success",
    pull_id: " 048dc299-6e38-4e67-a72d-be80a8b62091",
  },
  {
    time: "10:00 AM",
    dealer_ship: " Harry",
    employee: "Alex ",
    customer: "Robert ",
    email: " robert@gmail.com",
    contact_number: " 401-255-2556",
    vehicle: "12123456712345678",
    status: "failed",
    pull_id: " 079dc299-6e38-4e67-a72e-be80a8b62081",
  },
  {
    time: "08:00 AM",
    dealer_ship: " Toyota Jones",
    employee: "wallace",
    customer: "Jones",
    email: " Jhon@gmail.com",
    contact_number: " 401-255-2556",
    vehicle: "12357998881234567",
    status: "success",
    pull_id: " 097dc299-6e38-4e67-a72d-be80a8b62071",
  },
];
export const response = [
  {
    month: " MAY 2023",
    subscription_cost: "$250",
    max_pull: " 152",
    of_pull: "111",
    per_pull_coverage: "$1.5",
    docs_data: "Docs",
  },
  {
    month: " JUNE 2023",
    subscription_cost: "$270",
    max_pull: " 165",
    of_pull: "198",
    per_pull_coverage: "$1.8",
    docs_data: "Data",
  },
  {
    month: " APRIL 2023",
    subscription_cost: "$280",
    max_pull: " 192",
    of_pull: "191",
    per_pull_coverage: "$1.9",
    docs_data: "Docs",
  },
];
export const customerDetails = {
  name: "Kevin hasley",
  email: "kev@gmail.com",
  contact_number: "(401) 525-2568",
  street: "123 Any where",
  city: "Bell",
  state: "NY",
  zip_code: "56888",
};
export const pullDetails = {
  pull_id: "048dc299-6e38-4e67-a72d-be80a8b62091",
  carrier: "PROGRESSIVE",
  policies: "HOME,AUTO,UMBRELLA",
  documents: "Insurance Id Card,Auto Declarations",
};
export const dealerDetails = {
  name: "Jones Toyata",
  status: " ACTIVE",
  contact_name: "Wallace Stuart",
  first_name: "Wallace",
  contact_email: "wallace@gmail.com",
  last_name: "Stuart",
  address: " 1508 Belair Rd,Bel Air,MD 21041",
  contact_number: "410-879-6400",
  main_contact_number: "590-876-8907",
  subscription_cost: "$420",
  max_pull: "$540",
  per_pull_overage: "$5.4",
  docs_data: "data",
  email: "admin@jonestoyoata.com",
};
export const subscriptionDetails = {
  subscription_cost: "$420",
  max_pull: "$540",
  per_pull_overage: "$5.4",
  docs_data: "data",
};
export const emailDetails = {
  email: "admin@jones.com",
  subject: "Bill Report for month April 2023",
  message: "Hello jones",
  attachment: "Jonestoyota-APR-2023.xlsx",
};
export const userDetails = [
  {
    full_name: "Flyn Gayale",
    first_name: "Flyn",
    last_name: "Gayale",
    email: "flyn@everify.com",
    mobile_number: "(200)966-1254",
    completed_verifications: "10",
    current_target: "20",
  },
  {
    full_name: "Kelvin Gayale",
    first_name: "Kelvin",
    last_name: "Gayale",
    email: "kelvin@everify.com",
    mobile_number: "(200)966-1254",
    completed_verifications: "40",
    current_target: "30",
  },
  {
    full_name: "William Gayale",
    first_name: "William",
    last_name: "Gayale",
    email: "William@everify.com",
    mobile_number: "(300)966-1259",
    completed_verifications: "10",
    current_target: "20",
  },
  {
    full_name: "Chris Gayale",
    first_name: "Chris",
    last_name: "Gayale",
    email: "chris@everify.com",
    mobile_number: "(200)966-1289",
    completed_verifications: "50",
    current_target: "22",
  },
  {
    full_name: "David Gayale",
    first_name: "David",
    last_name: "Gayale",
    email: "david@everify.com",
    mobile_number: "(500)966-1254",
    completed_verifications: "50",
    current_target: "10",
  },
];
export const accordianDetails = [
  {
    title: "Privacy Consent",
    body: ["~ Accepting Privacy Consent", "~Insurance Carriers"],
    status: true,
  },
  {
    title: "Insurance Carriers",
    body: ["~ Selected USAA"],
    status: false,
  },
  {
    title: "Provider Login",
    body: ["~ Logging into carrier", 
    "~ Carrier login successfull"],
    status: true,
  },
  {
    title: "Canopy Webhook",
    body: ["~ fetching insurance details", "~ pull failed in time out"],
    status: false,
  },
  {
    title: "Pull Insurance",
    body: ["~ fetching insurance details", "~ pull failed in time out"],
    status: false,
  },
];
